import { render } from "./Parametrics.vue?vue&type=template&id=5dd1c100&scoped=true"
import script from "./Parametrics.vue?vue&type=script&lang=js"
export * from "./Parametrics.vue?vue&type=script&lang=js"

import "./Parametrics.vue?vue&type=style&index=0&id=5dd1c100&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd1c100"]])

export default __exports__